// React import
import React from 'react';
import {bindActionCreators} from "redux";
import {setPage} from "../../actions";
import {connect} from "react-redux";
// Styles imports
import './WalletBaseStatItem.css';
import '../../util.css'
// Svg icons imports
import { ReactComponent as CalculatorSvg } from '../../svg-icons/calculator.svg';
import { ReactComponent as ChartSquareSvg } from '../../svg-icons/chart-square.svg';
import { ReactComponent as TicketSvg } from '../../svg-icons/ticket.svg';
import { ReactComponent as WalletProfitSvg } from '../../svg-icons/wallet-profit.svg';
import { ReactComponent as ClockSvg } from '../../svg-icons/clock.svg';
import { ReactComponent as ShoppingCartSvg } from '../../svg-icons/shopping-cart.svg';
import { ReactComponent as DirectUpSvg } from '../../svg-icons/arrow-up.svg';
// Consts imports
import {
    RED,
    ORANGE,
    YELLOW,
    EMERALD,
    GREEN,
    LEVEL_FEATURES,
    PAGE_UPGRADE,
    WALLET_PROFIT,
    WALLET_PNL,
    WALLET_WIN_RATE,
    WALLET_TRADES,
    WALLET_AVERAGE_TRADE_TIME,
    WALLET_AVERAGE_BUY_VOLUME
} from "../../consts/consts";

function Title(props) {

    const { type } = props;

    let title = null

    if (type === WALLET_PROFIT) {
        title = "Gross Profit"
    } else if (type === WALLET_PNL) {
        title = "PnL"
    } else if (type === WALLET_WIN_RATE) {
        title = "Win Rate"
    } else if (type === WALLET_TRADES) {
        title = "Trades"
    } else if (type === WALLET_AVERAGE_TRADE_TIME) {
        title = "Average trade time"
    } else if (type === WALLET_AVERAGE_BUY_VOLUME) {
        title = "Average buy volume"
    } else {
        return null
    }

    return (
        <span className={"check-wallet__stats-item__block check-wallet__stats-item__block_text "}>
            {title}
        </span>
    );

}

function AvailableTitle(props) {

    const { level } = props;

    return (
        <span className={"check-wallet__stats-item__block_text_available "}>
            Upgrade to <br/>AI level {level}
        </span>
    );

}

function Indicator(props) {

    const { indicator } = props;

    let indicatorStyle = ""

    if (indicator === RED) {
        indicatorStyle = "check-wallet__stats-item__item-indicator_red"
    } else if (indicator === ORANGE) {
        indicatorStyle = "check-wallet__stats-item__item-indicator_orange"
    } else if (indicator === YELLOW) {
        indicatorStyle = "check-wallet__stats-item__item-indicator_yellow"
    } else if (indicator === EMERALD) {
        indicatorStyle = "check-wallet__stats-item__item-indicator_emerald"
    } else if (indicator === GREEN) {
        indicatorStyle = "check-wallet__stats-item__item-indicator_green"
    } else {
        return null
    }

    return (
        <div className={"check-wallet__stats-item__item-indicator " + indicatorStyle}></div>
    );

}

function Stat(props) {

    const { stat } = props;

    return (
        <span className={"check-wallet__stats-item__block check-wallet__stats-item__main-stat"}>
            {stat}
        </span>
    );

}

function Description(props) {

    const { firstDescription, secondDescription, type, aiLevel } = props;

    if (aiLevel < 5 && (type === WALLET_PROFIT || type === WALLET_PNL)) {
        return (
            <span className={"check-wallet__stats-item__block"}>
                {firstDescription}<br/>Unrealized: AI Level 5
            </span>
        );
    } else {
        return (
            <span className={"check-wallet__stats-item__block"}>
                {firstDescription}<br/>{secondDescription}
            </span>
        );
    }
}

function Icon(props) {

    const { type } = props;

    if (type === WALLET_PROFIT) {
        return (<WalletProfitSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else if (type === WALLET_PNL) {
        return (<CalculatorSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else if (type === WALLET_WIN_RATE) {
        return (<TicketSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else if (type === WALLET_TRADES) {
        return (<ChartSquareSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else if (type === WALLET_AVERAGE_TRADE_TIME) {
        return (<ClockSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else if (type === WALLET_AVERAGE_BUY_VOLUME) {
        return (<ShoppingCartSvg className={"check-wallet-stats-block-item-icon"}/>);
    } else {
        return null
    }

}

class WalletBaseStatItem extends React.Component {

    constructor(props) {
        super(props);
    }

    handleUpgradeClick = () => {
        const { setPage } = this.props;
        setPage(PAGE_UPGRADE);
    };

    render () {
        const {type, indicator, stat, firstDescription, secondDescription, aiLevel} = this.props;
        let aiLevelInt = parseInt(aiLevel);
        if ( aiLevelInt < LEVEL_FEATURES[type]) {
            return(
                <div className={"check-wallet__stats-item-available"} onClick={this.handleUpgradeClick}>

                    <DirectUpSvg className={"check-wallet-stats-block-item-icon-direct-up"}/>
                    <AvailableTitle level={LEVEL_FEATURES[type]}/>
                </div>
            );
        }
        else {
            return(
                <div className={"check-wallet__stats-item"}>
                    <Indicator indicator={indicator}/>
                    <Title type={type}/>
                    <Stat stat={stat}/>
                    <Description firstDescription={firstDescription} secondDescription={secondDescription}
                                 type={type} aiLevel={aiLevelInt}/>
                    <Icon type={type}/>
                </div>
            );
        }

    }

}

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setPage,
        },
        dispatch
    );

export default connect(null, mapDispatchToProps)(WalletBaseStatItem);